module.exports = __webpack_public_path__ + "img/Sphynx-Ninja-Logo-Template.jpg";